
export default {
    name: 'Footer',
    created() {
        this.$nextTick(function () {
            // 使用下拉菜单
            this._$.Select2('.select2')
           this.GetMenu()

        })
    },
    mounted() {
        this.$nextTick(function () {

        })
    },
    data() {
        return {
            FooterData: [],// 底部全部的数据
            NavData: this.$router.options.routes.filter((_, index) => index > 3),// 路由数组
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
               // 获取数据
        GetMenu: function () {
            $.ajax({
                type: "GET",
                url: process.env.VUE_APP_API + "GetMenu",
                data: { lang: localStorage.getItem('Language') || 1 },
                dataType: "json",
                success: (res) => {
                    if (res.status === "SUCCESS") {
                  
                        this.FooterData = res.footer
                        console.log(res);
                        
                    }
                },
                error: function (error) {
                    console.log(error);
                }
            });
        },
    
 
        scrollToTop: function () {
            $("html, body").animate({ scrollTop: 0 }, 100);
        }
    },
    components: {


    }
}
